import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Lock, User } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // BOXVERRA Admin credentials
    if (formData.email === 'admin@boxverra.com' && formData.password === 'boxverraretail0411') {
      localStorage.setItem('admin_token', 'admin-authenticated');
      toast({
        title: 'Welcome Admin!',
        description: 'Successfully logged in to BOXVERRA admin panel.'
      });
      navigate('/admin');
    } else {
      toast({
        title: 'Login failed',
        description: 'Invalid credentials',
        variant: 'destructive'
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="max-w-md w-full">
        <div className="bg-[#141414] rounded-2xl shadow-xl shadow-[#D4AF37]/10 p-10 border border-[#D4AF37]/20">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#B8960C] rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-[#D4AF37]/30">
              <span className="text-[#0A0A0A] text-3xl font-bold font-heading">B</span>
            </div>
            <h1 className="text-4xl font-bold text-white mb-2 font-heading">Admin Panel</h1>
            <p className="text-lg text-[#D4AF37] font-body">BOXVERRA</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="text-lg font-body text-white">Email</Label>
              <div className="relative mt-2">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 h-6 w-6 text-[#888888]" />
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="pl-14 py-7 text-xl font-body border-2 border-[#D4AF37]/30 bg-[#0A0A0A] text-white placeholder-[#888888] focus:border-[#D4AF37]"
                  placeholder="admin@boxverra.com"
                  required
                />
              </div>
            </div>

            <div>
              <Label className="text-lg font-body text-white">Password</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-6 w-6 text-[#888888]" />
                <Input
                  type="password"
                  value={formData.password}
                  onChange={(e) => setFormData({...formData, password: e.target.value})}
                  className="pl-14 py-7 text-xl font-body border-2 border-[#D4AF37]/30 bg-[#0A0A0A] text-white placeholder-[#888888] focus:border-[#D4AF37]"
                  placeholder="Enter password"
                  required
                />
              </div>
            </div>

            <Button
              type="submit"
              className="w-full bg-[#D4AF37] hover:bg-[#B8960C] text-[#0A0A0A] py-7 text-2xl font-bold font-body"
            >
              Sign In to Admin
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
